import React from "react";
import { Col, Row, Div } from "../../grid";
import {
  LinkStyled,
  Bold,
  Paragraph,
} from "../../typography";
import {
  dateModes,
  dateTypes,
} from "../../../features/commerce/delivery/dates";
import { isTomorrow, dateFormat, getSelfText } from "../../../lib/date";
import TimesSelect from "./TimesSelect";

const onChooseFrom = (onChoose, prevValue, value, possibleTimes) => {
  if (!value) {
    onChoose(null);
  }
  const intValue = parseInt(value, 10);
  if (intValue <= prevValue.toTime - 4) {
    onChoose({ fromTime: intValue, toTime: prevValue.toTime });
  } else {
    const { value: toTime } = possibleTimes.find(
      ({ value }) => value >= intValue + 4
    );
    onChoose({ fromTime: intValue, toTime });
  }
};

const onChooseTo = (onChoose, prevValue, value) => {
  const intValue = parseInt(value, 10);
  onChoose({ fromTime: prevValue.fromTime, toTime: intValue });
};
const possibleTimes = [
  { value: 8, time: "8:00" },
  { value: 9, time: "9:00" },
  { value: 10, time: "10:00" },
  { value: 11, time: "11:00" },
  { value: 12, time: "12:00" },
  { value: 13, time: "13:00" },
  { value: 14, time: "14:00" },
  { value: 15, time: "15:00" },
  { value: 16, time: "16:00" },
];
const possibleTimesPickup = [
  ...possibleTimes,
  { value: -10, time: getSelfText },
];

const possibleTimes23 = [
  { value: 8, time: "8:00" },
  { value: 9, time: "9:00" },
  { value: 10, time: "10:00" },
  { value: 11, time: "11:00" },
  { value: 12, time: "12:00" },
  { value: 13, time: "13:00" },
];

const possibleTimes23Pickup = [
  ...possibleTimes23,
  { value: -10, time: getSelfText },
];

const specialDays = ["20191223", "20191227", "20191230"];
export default ({
  value,
  onChoose,
  error,
  onChangeMode,
  disabled,
  date,
  dateType,
}) => {
  const isSpecialDay = date && specialDays.includes(date.format(dateFormat));
  let currentPossibleTimes = isSpecialDay ? possibleTimes23 : possibleTimes;
  let deducter = 1;
  if (dateType === dateTypes.pickup) {
    currentPossibleTimes = isSpecialDay ? possibleTimes23Pickup : possibleTimesPickup;
    deducter = 2;
  }
  return (
    <div>
      <div>
        <Row>
          <Col xs={6} padding="0 5px 0 15px">
            <TimesSelect
              value={value.fromTime}
              onChange={({ target: { value: value2 } }) =>
                onChooseFrom(onChoose, value, value2, currentPossibleTimes)
              }
              disabled={disabled}
              error={error}
            >
              {currentPossibleTimes
                .filter(
                  ({ value: value2 }, index) =>
                    value2 === -10 || index === 0 ||
                    value2 + 4 <=
                      currentPossibleTimes[currentPossibleTimes.length - deducter]
                        .value
                )
                .map(({ value: value2, time }) => (
                  <option key={value2} value={value2}>
                    {time}
                  </option>
                ))}
            </TimesSelect>
          </Col>
          <Col xs={6} padding="0 15px 0 5px">
            {value.fromTime === -10 && (
              <TimesSelect value={-1} disabled>
                <option value={-1}>-</option>
              </TimesSelect>
            )}
            {value.fromTime !== -10 && (
              <TimesSelect
                value={value.toTime}
                onChange={({ target: { value: value2 } }) =>
                  onChooseTo(onChoose, value, value2)
                }
                disabled={disabled}
                error={error}
              >
                {currentPossibleTimes
                  .filter(
                    ({ value: value2 }, index) =>
                      value2 !== -10 &&
                      index === currentPossibleTimes.length - deducter ||
                      value2 - 4 >= value.fromTime
                  )
                  .map(({ value: value2, time }) => (
                    <option key={value2} value={value2}>
                      {time}
                    </option>
                  ))}
              </TimesSelect>
            )}
          </Col>
        </Row>
        {!disabled && (
          <>
            <Row>
              <Col xs={12} paddingTop="0px">
                <Div padding="0 10px">
                  {isTomorrow(date) && dateType === dateTypes.delivery && (
                    <Paragraph fontSize="12px">
                      Bestilling til dagen efter skal foretages inden kl. 16.
                      Efter kl. 16 kræver bestilling til dagen efter telefonisk
                      aftale
                    </Paragraph>
                  )}
                  <Paragraph fontSize="12px">
                    Skriv i kommentar feltet hvis vi skal ringe f.eks. 30 min før{" "}
                    {dateType === dateTypes.delivery ? "levering" : "afhentning"}
                  </Paragraph>
                  {!isSpecialDay && (
                    <LinkStyled
                      action
                      blue
                      onClick={() => onChangeMode(dateModes.night)}
                    >
                      Vælg tid efter normal åbningstid eller <Bold>{dateType === dateTypes.delivery ? 'levering' : 'afhentning'} til DHL</Bold>
                    </LinkStyled>
                  )}
                </Div>
              </Col>
            </Row>
          </>
        )}
      </div>
    </div>
  );
};
